import React from 'react';

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';

interface FilterDrawerHelpers {
  /** Cierra el drawer (p. ej. al seleccionar un usuario). */
  close: () => void;
}

interface FilterDrawerProps {
  /** Filtros como render-prop; recibe `close` para cerrarse al seleccionar. */
  children: (helpers: FilterDrawerHelpers) => React.ReactNode;
  /** Texto del botón que abre el drawer. Default "Filtros". */
  buttonLabel?: string;
}

/**
 * Drawer de filtros para móvil: un botón que abre un modal con los filtros.
 * Es **dueño** del `useDisclosure` y expone `close` a sus children, de modo que
 * el cierre al seleccionar lo decide quien usa el drawer.
 */
export function FilterDrawer({
  children,
  buttonLabel = 'Filtros',
}: FilterDrawerProps) {
  const {isOpen, onOpen, onClose} = useDisclosure();

  return (
    <>
      <Button onClick={onOpen} colorScheme='darkBlue'>
        {buttonLabel}
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent w='max-content' p={2}>
          <ModalBody>{children({close: onClose})}</ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
